import ThDayHdg from "./ThDayHdg";
import TdDayVal from "./TdDayVal";

const Table2 = ({ details }) => {
  return (
    <table
      className="approved assigned"
      style={{ marginTop: "0", marginBottom: "0" }}
    >
      <thead>
        <tr>
          <ThDayHdg d="S" />
          <ThDayHdg d="M" />
          <ThDayHdg d="T" />
          <ThDayHdg d="W" />
          <ThDayHdg d="T" />
          <ThDayHdg d="F" />
          <ThDayHdg d="S" />
          <ThDayHdg d="S" />
          <ThDayHdg d="M" />
        </tr>
      </thead>
      <tbody>
        <tr>
          <TdDayVal status={details.sun1} />
          <TdDayVal status={details.mon1} />
          <TdDayVal status={details.tue1} />
          <TdDayVal status={details.wed1} />
          <TdDayVal status={details.thu1} />
          <TdDayVal status={details.fri1} />
          <TdDayVal status={details.sat1} />
          <TdDayVal status={details.sun2} />
          <TdDayVal status={details.mon2} />
        </tr>
      </tbody>
    </table>
  );
};

export default Table2;
